import Signature from 'components/content/signature/Signature';
import * as React from 'react';
export default {
  Signature,
  React
};